import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import URLstateContext from "../../../provider/CommonContext";
import LinearProgress from "@mui/material/LinearProgress";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import animation from "../../../images/jm-animation.gif";
import * as am5percent from "@amcharts/amcharts5/percent";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import "./AditioanlSchemeRelated.css";

import { format, parseISO } from "date-fns";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Weblink() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures/Additional-Scheme-Related-Disclosures",
      "jmf_sid-disclosures_additional-scheme-disclosures"
    );
    // trackPageView(
    //   "http://localhost:710/SIDdisclosures/Additional-Scheme-Related-Disclosures",
    //   "jmf_sid-disclosures_additional-scheme-disclosures"
    // );

    trackEvent({
      category: "Static Page",
      action: "SIDdisclosuresAdditional Scheme Page Loaded",
      label: "jmf_sid-disclosures_additional-scheme-disclosures",
      value: 1,
    });
  }, []);

  
  const { BaseURL } = useContext(URLstateContext);
  const [chartdata, setchartdata] = useState([]);
  const [data, setData] = useState([]);
  const [Datafact, setDatafact] = useState([]);
  const [selectedFundName, setSelectedFundName] = useState("");
  const [loadingshow, setLoadingshow] = useState(false);

  useEffect(() => {
    setLoadingshow(true);
    GetPostMethodData(BaseURL + "GetTop10HoldingandSector")
      .then((data) => {
        setLoadingshow(false);
        if (data.data != null && data.data.length > 0) {
          setDatafact(DecryptAESdata(data.data));
        }
      })
      .catch((error) => {
        setLoadingshow(false);
        console.error("Error fetching data:", error);
      });
  }, [BaseURL]);

  useEffect(() => {
    // Set default selected fund name to the first one
    if (Datafact.length > 0) {
      setSelectedFundName(Datafact[0]?.Properties?.FundName || "");
    }
  }, [Datafact]);
  //piechart functionallity

  useEffect(() => {
    if (selectedFundName && Datafact.length > 0) {
      const sectorData = Datafact.filter(
        (item) => item.Properties.Sector && item.Properties.Percentage
      );
      // const filteredData = Datafact.filter(item => item.Properties.FundName === selectedFundName && item.Properties.sector && item.Properties.Percentage);
      // const filteredData = sectorData.filter(item => item.Properties.FundName === selectedFundName);

      // const top10Sectors = filteredData.slice(0, 10).map(item => ({ category: item.Properties.Sector, value: item.Properties.Percentage }));

      const filteredData = sectorData
        .filter((item) => item.Properties.FundName === selectedFundName)
        .slice(0, 10);

      const top10Sectors = filteredData.map((item) => ({
        category: item.Properties.Sector,
        value: item.Properties.Percentage,
      }));

      setchartdata(top10Sectors);
    }
  }, [selectedFundName, Datafact]);

  useLayoutEffect(() => {
    am5.addLicense("AM5C420959785");
    var root = am5.Root.new("SectorChart");
    root.setThemes([am5themes_Animated.new(root)]);

    var chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        radius: am5.percent(70), //updated by me
        layout: root.verticalLayout,

      })
    );

    var series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        legendLabelText: "{category}",
      })
    );

    series
      .get("colors")
      .set("colors", [
        am5.color("#3bafcb"),
        am5.color("#25d8ff"),
        am5.color("#ace3df"),
        am5.color("#063b73"),
        am5.color("#869d9f"),
      ]);

    function generateChartData() {
      let chartData = [];
      if (chartdata != null) {
        for (var i = 0; i < chartdata.length; i++) {
          if (chartdata[i].value != null) {
            chartData.push({
              category: chartdata[i].category,
              value: parseFloat(chartdata[i].value).toFixed(2),
            });
          }
        }
      }
      return chartData;
    }
    let data = generateChartData();

    series.data.setAll(data);

    // series.ticks.template.set("visible", true);
    // series.labels.template.set("forceHidden", true);

    series.labels.template.setAll({
      maxWidth: 100,
      oversizedBehavior: "wrap",
      fontSize: 9,
      text: "{value}%",
    });

    var legend = chart.children.push(
      am5.Legend.new(root, {
        dx: 80,
        clickTarget: "none",
        centerX: am5.percent(75),
        x: am5.percent(50),
        layout: root.verticalLayout,
        // layout: am5.GridLayout.new(root, {
        //     maxColumns: 2,
        //     fixedWidthGrid: true
        // })
      })
    );
    legend.valueLabels.template.set("forceHidden", true);
    legend.data.setAll(series.dataItems);

    series.appear(1000, 100);
    return () => {
      root.dispose();
    };
  }, [chartdata]);

  const uniqueFundNames = [
    ...new Set(Datafact.map((item) => item.Properties.FundName)),
  ];

  // Filter top 10 holdings based on selected fund name
  const filteredData = Datafact.filter(
    (item) => item.Properties.FundName === selectedFundName
  ).slice(0, 10);

  // Handle dropdown change
  const handleDropdownChange = (event) => {
    setSelectedFundName(event.target.value);
  };

  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  return (
    <main className="product-main product_fund-summary-sc">
      <div className="select-container top-select">
        {/* <select className='holdsec_drop data-selector ' value={selectedFundName} onChange={handleDropdownChange}>
                                            <option value="">Select FundName</option>
                                            {uniqueFundNames.map((fundName, index) => (
                                                <option key={index} value={fundName}>{fundName}</option>
                                            ))}
                                        </select>
                                        <i class="fa fa-caret-down" aria-hidden="true"></i>
            </div>
                 */}
              <label htmlFor="fund-name-select" className="sr-only">
              Fund Name
            </label>   

        <select
          className="holdsec_drop data-selector "
          value={selectedFundName}
          onChange={handleDropdownChange}
        >
          <option value="">Select Fund Name</option>
          {uniqueFundNames.map((fundName, index) => (
            <option key={index} value={fundName}>
              {fundName}
            </option>
          ))}
        </select>
        <i class="fa fa-caret-down" aria-hidden="true"></i>
      </div>

      <div className="DateAsOnadd">
        {filteredData && filteredData.length > 0 && (
          <p className="text-left DateAson">
            <span>Data as on - </span>
            {filteredData[0].Properties && filteredData[0].Properties.AsonDate
              ? format(
                  parseISO(filteredData[0].Properties.AsonDate),
                  "do MMM, yyyy"
                )
              : ""}
          </p>
        )}
      </div>

      <div class="gradiant-head-flex">
        <div className="gradiant-head-box">
          <div className="gradiant-head-container p-relative">
            <h2 className="gradiant-head left">Top 10 Holdings</h2>
          </div>
          <div className="gradiant-content">
            <div className="padding-box-inner HoldingFund">
              <div className="img-container">
                {Datafact.length === 0 ? " " : ""}
                {loadingshow ? (
                  <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                    <img src={animation} alt="" aria-hidden="true" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  // <div>

                  //     {filteredData.map((item, index) => (
                  //         <div key={index}>
                  //             <div className="d-flex justify-content-between mb-1">
                  //                 <p className="holding-progress-text pr-sm-4">{item.Properties.IssuerLongName}</p>
                  //                 <p className="holding-progress-text percentHolding">{item.Properties.PercentToAss}%</p>
                  //             </div>
                  //             <LinearProgress variant="determinate" value={item.Properties.PercentToAss} />
                  //             <br />
                  //         </div>
                  //     ))}

                  // </div>

                 <>
  <div>
    {filteredData.length === 0 ? (
      <span className="errormsgComNew" role="alert">No Data Available</span>
    ) : (
      filteredData.slice(0, 10).map((item, index) => {
        const issuer = item?.Properties?.IssuerLongName || "Unknown issuer";
        const percent = parseFloat(item?.Properties?.PercentToAss ?? 0);
          <div>
    {filteredData.length === 0 ? (
      <span className="errormsgComNew" role="alert">No Data Available</span>
    ) : (
      filteredData.slice(0, 10).map((item, index) => {
        const issuer = item?.Properties?.IssuerLongName || "Unknown issuer";
        const percent = parseFloat(item?.Properties?.PercentToAss ?? 0);
          <div>
    {filteredData.length === 0 ? (
      <span className="errormsgComNew" role="alert">No Data Available</span>
    ) : (
      filteredData.slice(0, 10).map((item, index) => {
        const issuer = item?.Properties?.IssuerLongName || "Unknown issuer";
        const percent = parseFloat(item?.Properties?.PercentToAss ?? 0);
        const labelId = `progress-label-${index}`;

        return (
          <div key={index}>
            
            {/* Label + Value */}
            <div
              className="d-flex justify-content-between mb-1"
              // id={`progress-label-${index}`}
              id={labelId}
            >
              <p className="holding-progress-text pr-sm-4">
                {issuer}
              </p>
              <p className="holding-progress-text percentHolding">
                {percent}%
              </p>
            </div>

            {/* Progress Bar */}
            <div style={{ width: "100%" }}>
              <LinearProgress
                variant="determinate"
                value={isNaN(percent) ? 0 : percent}
                // componentsProps={{
                //   root: {
                //     "aria-label": `${issuer} holding ${percent}%`,
                //     "aria-valuetext": `${percent}%`,
                //   },
                // }}
                // aria-label={`${issuer} holding ${percent}%`}
                aria-labelledby={labelId}
                aria-valuetext={`${percent}%`}
              />
            </div>

            <br />
          </div>
        );
      })
    )}
  </div>

        return (
          <div key={index}>
            
            {/* Label + Value */}
            <div
              className="d-flex justify-content-between mb-1"
              id={`progress-label-${index}`}
            >
              <p className="holding-progress-text pr-sm-4">
                {issuer}
              </p>
              <p className="holding-progress-text percentHolding">
                {percent}%
              </p>
            </div>

            {/* Progress Bar */}
            <div style={{ width: "100%" }}>
              <LinearProgress
                variant="determinate"
                value={isNaN(percent) ? 0 : percent}
                componentsProps={{
                  root: {
                    "aria-label": `${issuer} holding ${percent}%`,
                    "aria-valuetext": `${percent}%`,
                  },
                }}
              />
            </div>

            <br />
          </div>
        );
      })
    )}
  </div>

        return (
          <div key={index}>
            
            {/* Label + Value */}
            <div
              className="d-flex justify-content-between mb-1"
              id={`progress-label-${index}`}
            >
              <p className="holding-progress-text pr-sm-4">
                {issuer}
              </p>
              <p className="holding-progress-text percentHolding">
                {percent}%
              </p>
            </div>

            {/* Progress Bar */}
            <div style={{ width: "100%" }}>
              <LinearProgress
                variant="determinate"
                value={isNaN(percent) ? 0 : percent}
                componentsProps={{
                  root: {
                    "aria-label": `${issuer} holding ${percent}%`,
                    "aria-valuetext": `${percent}%`,
                  },
                }}
              />
            </div>

            <br />
          </div>
        );
      })
    )}
  </div>
</>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="gradiant-head-box">
          <div className="gradiant-head-container">
            <h2 className="gradiant-head">Top 7 Sectors</h2>
          </div>
          <div className="gradiant-content">
            <div className="padding-box-inner paddingChart">
              {filteredData.length === 0 && !loadingshow ? (
                <span className="errormsgComNew" role="alert">No Data Found !!!</span>
              ) : (
                ""
              )}
              {loadingshow ? (
                <div className="textcentervertex">
                  <img src={animation} alt="Loading" />
                  <div className="model_popup">Please Wait...</div>
                </div>
              ) : (
                ""
              )}
              <div id="SectorChart" style={{ width: "100%", height: "500px" }}>
                {/* Your chart component or other content goes here */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Weblink;
